import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map, take } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { Api } from '../api.service';
import { Context } from '@models/matter';
import { MatterEmailRequest } from './email-integration.models';

export interface EmailConvertTemplateResponse {
	convertedTemplate: string;
}

@Injectable({
	providedIn: 'root',
})
/**
 * Wrapper for the C# EmailIntegrationController.
 */
export class EmailIntegrationApiService extends Api {
	constructor(private http: HttpClient) {
		super(http);
	}

	/**
	 * Converts a template using matter tags
	 * @param businessId - The BusinessId to use for the conversion.
	 * @param matterId - The MatterId to use for the conversion.
	 * @param template - The template to convert.
	 * @param context - Optional context to use for the conversion.
	 * @param additionalTags - Optional additional tags to include in the conversion (used to augment or override existing tags).
	 * @returns An Observable that emits a String.
	 */
	convertEmailTemplate(
		matterId: string,
		businessId: string,
		template: string,
		context?: Context,
		additionalTags?: Record<string, unknown>,
	): Observable<string> {
		const url = `${environment.api.baseUrl}/email-integration/convert-template`;

		return this.http
			.post<EmailConvertTemplateResponse>(url, {
				matterId,
				businessId,
				template,
				context,
				additionalTags,
			})
			.pipe(
				take(1),
				map((results) => results.convertedTemplate),
			);
	}

	sendEmailViaOutlook(
		matterEmailRequest: MatterEmailRequest,
	): Observable<string> {
		const url = `${environment.api.baseUrl}/closer/email/messages/send`;

		return this.http.post<string>(url, matterEmailRequest).pipe(take(1));
	}
}
